module.exports = __webpack_public_path__ + "img/c12.d6434cf6.png";